<div (keydown.enter)="submit()" class="flex flex-col gap-4">
  <div class="flex items-end gap-4">
    <div class="flex-1">
      <elcia-text-input [control]="form.controls.firstName" [label]="'user.first-name' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="form.controls.lastName" [label]="'user.last-name' | translate"/>
    </div>
  </div>

  <div class="flex items-end gap-4">
    <div class="flex-1">
      <elcia-text-input [control]="form.controls.email" [label]="'user.email' | translate" autocomplete="off"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="form.controls.password" [label]="'user.password' | translate"
                        type="password" autocomplete="new-password"/>
    </div>
  </div>

  <div class="flex items-end gap-4">
    <div class="flex-1">
      <elcia-legal-entity-dropdown [control]="form.controls.legalEntityId"/>
    </div>
    <div class="flex-1">
      <elcia-local-dropdown [control]="form.controls.localeIsoCode"/>
    </div>
  </div>
</div>
